import { Icon } from '@iconify/react';
import type React from 'react';

import './PwaInstallSheet.scss';

export interface PwaInstallSheetProps {
  appIconPath?: string;
  /** What installs: Android's Install button, or the iPhone's steps. */
  children: React.ReactNode;
  closeLabel: string;
  description: string;
  onClose: () => void;
  title: string;
}

/**
 * The install sheet both phones share: the icon the home screen will get, the
 * title, the description and what installs. A tap on the scrim or the X only
 * closes it; a tap inside the sheet keeps it.
 */
const PwaInstallSheet = ({
  appIconPath,
  children,
  closeLabel,
  description,
  onClose,
  title,
}: PwaInstallSheetProps) => (
  <div
    className="Mfw-PwaInstallSheet-overlay"
    data-testid="pwa-install-prompt-scrim"
    onClick={onClose}
  >
    <div
      aria-labelledby="pwa-install-sheet-title"
      className="Mfw-PwaInstallSheet-root"
      onClick={(event) => event.stopPropagation()}
      role="dialog"
    >
      <div className="Mfw-PwaInstallSheet-header">
        <div className="Mfw-PwaInstallSheet-header-left">
          <img className="Mfw-PwaInstallSheet-icon" src={appIconPath} alt="" />
          <div className="Mfw-PwaInstallSheet-title-container">
            <span
              className="Mfw-PwaInstallSheet-title"
              id="pwa-install-sheet-title"
            >
              {title}
            </span>
            <span className="Mfw-PwaInstallSheet-subtitle">
              {window.location.origin}
            </span>
          </div>
        </div>
        <button
          aria-label={closeLabel}
          className="Mfw-PwaInstallSheet-closeButton"
          data-testid="pwa-install-prompt-close"
          onClick={onClose}
        >
          <Icon icon="ic-baseline-close" height={24} width={24} />
        </button>
      </div>

      <div className="Mfw-PwaInstallSheet-description">{description}</div>

      <div className="Mfw-PwaInstallSheet-actions">{children}</div>
    </div>
  </div>
);
export default PwaInstallSheet;
